import { HttpClient, HttpParams } from "@angular/common/http";
import { Injectable } from "@angular/core";
import { IGetTemplateListItem, ITemplateFilters } from "../templates/templates.service";
import { IPageableResponse } from "app/global/pagging.dto";
import { TemplateType } from "../templates/template.dto";


@Injectable({
  providedIn: 'root'
})

export class SignableEformService {
  constructor(private http: HttpClient) { }

  getSignableEformList(page: number, q: string, filter: ITemplateFilters = {}, p: string = '') {
    const params = new HttpParams()
      .set('page', page)
      .set('q', q)
      .set('p', p)
      .set('document_type_id', filter?.document_type_id ?? '')
      .set('language', filter?.language ?? 'all')
      .set('type', TemplateType.EFORM)
      .set('status', filter?.status ?? 'all');
    return this.http.get<IPageableResponse<IGetTemplateListItem> | IGetTemplateListItem[]>(`templates`, { params });
  }
}